import { Divider, FormControl, FormHelperText, InputLabel, makeStyles, MenuItem, Select, Theme } from "@material-ui/core";
import React from "react";
import { globalStyles } from "../style/GlobalStyles";

export type TipoImpresaProps = {
    id?: string,
    name?: string,
    label?: string,
    helperText?: string,
    value: any,
    onChange?: any,
    onBlur?: any,
}
export function TipoImpresa(props: TipoImpresaProps) {
    let error = props.value === (undefined || "" || "NON DEFINITO" || null);
    // const useStyles = makeStyles((theme: Theme) =>
    //     createStyles({
    //         // formControl: {
    //         //     margin: theme.spacing(1),
    //         // },
    //         // select: {
    //         //     width: "10rem",
    //         // },
    //         // bottomControlLabel: {
    //         //     verticalAlign: 'bottom',
    //         // },
    //     }),
    // );
    // const classes = useStyles();
    const gClasses = globalStyles();
    return (
        <FormControl className={gClasses.formControl}>
            <InputLabel htmlFor="tipoPrevidenza">{props.label ? props.label : "Tipologia"}</InputLabel>
            <Select
                className={gClasses.select}
                value={props.value}
                onChange={props.onChange}
                //onBlur={props.onBlur}
                inputProps={{
                    name: props.name,
                    id: props.id,
                }}
                error={error}
            >
                <MenuItem value={"NON DEFINITO"}>Non definito</MenuItem>
                <Divider></Divider>
                <MenuItem value={"PROFESSIONE"}>Professione</MenuItem>
                <Divider></Divider>
                <MenuItem value={"IMPRESA"}>Impresa individuale</MenuItem>
                <MenuItem value={"IMPRESA_FAMILIARE"}>Impresa familiare</MenuItem>
                <MenuItem value={"SOCIETA_DI_PERSONE"}>Società di persone</MenuItem>
                <MenuItem value={"SRL_TRASPARENTE"}>S.r.l trasparente</MenuItem>
                <MenuItem value={"SRL_NON_TRASPARENTE"}>S.r.l non trasparente</MenuItem>

            </Select>
            <FormHelperText error={error}>{error ? "Campo obbligatorio" : ""}</FormHelperText>
        </FormControl>
    )
}